import React, { useMemo } from 'react';
import isURL from 'validator/lib/isURL';
import { useHistory } from 'react-router-dom';
import './InfoTag.scss';
const infoIcon = '/assets/images/information-button-white.png';

const panitingMediaId = [
  {
    id: '693b85eb4f8835d9de003665',
    name: 'The Tricky Passage',
    url: '/gallery/the-tricky-passage',
  },
  {
    id: '693b85fe4f8835d9de00367c',
    name: 'Silk Road Or Silk River',
    url: '/gallery/silk-road-or-silk-river',
  },
  {
    id: '693b86474f8835d9de0036f2',
    name: 'The Vietnamese Aviators Meet Catherine Of Aragon In The Faroe Is',
    url: '/gallery/the-vietnamese-aviators-meet-catherine-of-aragon-in-the-faroe-islands',
  },
  {
    id: '693b865f4f8835d9de003711',
    name: 'Who Sail “OLD”',
    url: '/gallery/who-sail-old',
  },
  {
    id: '693b86704f8835d9de003734',
    name: 'The Perils of Ha Long bay',
    url: '/gallery/the-perils-of-ha-long-bay',
  },
  {
    id: '693b86874f8835d9de00375e',
    name: 'Taking The Tube To Florence',
    url: '/gallery/taking-the-tube-to-florence',
  },
  {
    id: '693b86934f8835d9de00378d',
    name: 'The Snake Charmer',
    url: '/gallery/the-snake-charmer',
  },
  {
    id: '693b86a04f8835d9de00379e',
    name: 'La Selva de Girasoles',
    url: '/gallery/la-selva-de-girasoles',
  },
  {
    id: '693b86ac4f8835d9de0037cc',
    name: 'Tropical Underwater',
    url: '/gallery/tropical-underwater',
  },
  {
    id: '693b86b94f8835d9de0037e1',
    name: 'Tropical Underwater 2',
    url: '/gallery/tropical-underwater-2',
  },
  {
    id: '693b86c74f8835d9de0037f2',
    name: 'The Wild Leaves',
    url: '/gallery/the-wild-leaves',
  },
  {
    id: '693b87a14f8835d9de00395a',
    name: 'TWINING CON HỔ 1',
    url: '/gallery/twining-con-ho-1',
  },
  {
    id: '693b88234f8835d9de003a3d',
    name: 'TWINING CON HỔ 2',
    url: '/gallery/twining-con-ho-2',
  },
  {
    id: '693b88094f8835d9de003a19',
    name: "ALL THE TIGER'S FRIENDS",
    url: '/gallery/all-the-tigers-friends',
  },
  {
    id: '693b86e14f8835d9de003807',
    name: 'Red-Shanked Doucs of The Marmalade',
    url: '/gallery/red-shanked-doucs-of-the-marmalade',
  },
  {
    id: '693b86fb4f8835d9de00383f',
    name: 'Lotus Gardener in Danang',
    url: '/gallery/lotus-gardener-in-danang',
  },
  {
    id: '693b87074f8835d9de00385d',
    name: 'Monkey Business in InterContinental Danang',
    url: '/gallery/monkey-business-in-intercontinental-danang',
  },
  {
    id: '693b87544f8835d9de0038d6',
    name: 'Cardamom Wild Elephant',
    url: '/gallery/cardamom-wild-elephant',
  },
  {
    id: '693b87784f8835d9de003919',
    name: 'The Douc’s in the Pink',
    url: '/gallery/the-doucs-in-the-pink',
  },
  {
    id: '693b88314f8835d9de003a78',
    name: 'THE BIRDS CONFERENCE',
    url: '/gallery/the-birds-conference',
  },
  {
    id: '693b87944f8835d9de003939',
    name: 'DOES ANYONE NEED SOME LEMONADE ?',
    url: '/gallery/does-anyone-need-some-lemonade',
  },
  {
    id: '693b88174f8835d9de003a2e',
    name: 'THE WILD ELEPHANT',
    url: '/gallery/the-wild-elephant',
  },
  {
    id: '693b88574f8835d9de003ae6',
    name: 'LONG LOST BROTHERS, GRIFFIN',
    url: '/gallery/long-lost-brothers-griffin',
  },
  {
    id: '693b87854f8835d9de003928',
    name: 'Wild Forest',
    url: '/gallery/wild-forest',
  },
];

const handleReadmoreURL = (readMoreURL) => {
  if (
    readMoreURL.split(':')[0] === 'https' ||
    readMoreURL.split(':')[0] === 'http'
  ) {
    return readMoreURL;
  }
  return '//' + readMoreURL;
};

const InfoTag = ({ detail, isDpTag = true }) => {
  const history = useHistory();
  const up = useMemo(
    () => detail.hotspot.location[1] > 0,
    [detail.hotspot.location]
  );
  const styles = useMemo(() => {
    return {
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%)',
      bottom: up ? '0' : null,
    };
  }, [up]);

  const isNotSpaceOrEmpty = (char) => {
    return char !== ' ' && char !== '';
  };

  const isPaintingMedia = useMemo(() => {
    return panitingMediaId.some((item) => item.id === detail.data._id);
  }, [detail.data._id]);

  if (isPaintingMedia) {
    const paintingItem = panitingMediaId.find(
      (item) => item.id === detail.data._id
    );

    return (
      <div
        className="painting-media-container"
        onClick={() => {
          if (!paintingItem?.url) return;

          try {
            // Lưu current URL để có thể quay lại khi close gallery
            // Sử dụng history.location nếu có, nếu không thì dùng window.location
            const previousUrl = history?.location
              ? history.location.pathname + history.location.search
              : window.location.pathname + window.location.search;

            // Thử dùng history.push() trước (không reload trang)
            // Truyền flag fromHotspot và previousUrl để biết được mở từ hotspot và quay lại được
            if (history && typeof history.push === 'function') {
              history.push({
                pathname: paintingItem.url,
                state: {
                  fromHotspot: true,
                  previousUrl: previousUrl,
                },
              });
            } else {
              // Fallback: dùng window.history.pushState() để đổi URL mà không reload
              window.history.pushState(
                { fromHotspot: true, previousUrl: previousUrl },
                '',
                paintingItem.url
              );
              // Dispatch popstate event để React Router biết URL đã thay đổi
              window.dispatchEvent(new PopStateEvent('popstate'));
            }
          } catch (error) {
            console.error('Error navigating:', error);
            // Nếu tất cả đều fail, dùng window.location với query param
            const url = new URL(paintingItem.url, window.location.origin);
            url.searchParams.set('fromHotspot', 'true');
            // Sử dụng window.location làm fallback nếu history không có
            const previousUrl = history?.location
              ? history.location.pathname + history.location.search
              : window.location.pathname + window.location.search;
            url.searchParams.set(
              'previousUrl',
              encodeURIComponent(previousUrl)
            );
            window.location.href = url.toString();
          }
        }}
      >
        <img src={infoIcon} alt="painting" />
      </div>
    );
  }

  if (isDpTag) {
    return (
      <div className="dp-info-tag-container">
        <div className="dp-info-tag-content">
          <div className="dp-info-tag-logo">
            <img src="/assets/images/logo/Vector.png" alt="logo" />
          </div>
          <h2>{detail.data.title}</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="info-tag inner-outline" style={styles || {}}>
      <div className="media-text ">
        <div className="title shadow-text" style={{ color: 'black' }}>
          <h2>{detail.data.title}</h2>
        </div>

        {isNotSpaceOrEmpty(detail.data.infoTag?.text) && (
          <p className="wrap-text" value={detail.data.infoTag?.text}>
            {detail.data.infoTag?.text}
          </p>
        )}

        {detail.data.infoTag?.readMoreUrl &&
          isURL(detail.data.infoTag?.readMoreUrl) && (
            <a
              className="card-link"
              href={handleReadmoreURL(detail.data.infoTag?.readMoreUrl)}
              target="_blank"
              rel="noreferrer"
            >
              <h5 className="infotag-title">Read more</h5>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="currentColor"
                className="bi bi-box-arrow-up-right"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                />
                <path
                  fillRule="evenodd"
                  d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                />
              </svg>
            </a>
          )}
      </div>
    </div>
  );
};

export default InfoTag;
